import RetirementCalculatorPage from "@/components/tools/RetirementCalculatorPage";

const RetirementCalculator = () => <RetirementCalculatorPage />;

export default RetirementCalculator;
